/* eslint-disable max-len */
import React from "react"
import Icon from "@ant-design/icons"

const MultipleChoiceSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#FFEBEB" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6Z"
      fill="#FFEBEB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.8225 8.13449C16.6027 7.94069 16.2638 7.95844 16.0655 8.17416L10.0655 14.7004L7.93395 12.3819C7.73563 12.1662 7.3967 12.1484 7.17692 12.3422C6.95714 12.536 6.93975 12.868 7.13807 13.0837L9.65908 15.8258C9.80223 15.9816 10.0186 16.0341 10.2106 15.9784C10.3098 15.9536 10.403 15.9008 10.4767 15.8206L16.8614 8.87599C17.0597 8.66027 17.0423 8.3283 16.8225 8.13449Z"
      fill="#E37879"
    />
  </svg>
)

const MultipleChoiceIcon = (props) => (
  <Icon component={MultipleChoiceSvg} {...props} />
)

export { MultipleChoiceIcon }
